<template>
<div>

    <v-slide-group class="slider uc" multiple show-arrows>
          <v-slide-item
            v-for="(testfield, index) in testfields"
            :key="index"
            disabled
          >
            <div
              class="ma-2 item"
            >
                <router-link :to="'/'+$home+'p/field/'+testfield.id">
                  <div class="img" v-if="testfield.src"><img :src="testfield.paththumb" alt="" /></div>
                  <div class="title">{{ testfield.title }}</div>
                  <div class="keywords">...</div>
                </router-link>
            </div>
          </v-slide-item>
        </v-slide-group>

    <!--
    <v-col cols="6" sm="6">
      <v-btn :to="{ name: 'Stage' }">
        NAO-Leseroboter
      </v-btn>
    </v-col>
    <v-col cols="6" sm="6">
        <v-btn :to="{ name: 'NLP' }">
          NLP
        </v-btn>
    </v-col>
    -->

</div>

</template>

<script>

    export default {
        name: 'Usecase_Testfields',
        data() {
            return {
                testfields: {}
            };
        },
        props: {
            usecaseid: {
                type: Number
            }
        },

        components: {

        },

        methods: {

            getConnectedByUsecaseId() {
                //console.log("getConnectedByUsecaseId()");
                let self = this;
                this.axios.get( this.$config.host+"/testfields/usecase/" + this.usecaseid ).then(function (response) {

                        //console.log("get TESTFIELDS by usecase id");
                        //console.log(response.data);
                        self.testfields = response.data;

                });
            },
            link(x) {
              console.log("link fkt:")
              console.log(x);
              this.$router.push({path: x});
            }

        },
        mounted() {
            //console.log("mount Usecase Testfields - Usecaseid: ");
            //console.log(this.usecaseid);
            this.getConnectedByUsecaseId();
        },
        watch: {
            usecaseid: function (values) {
                console.log("watch Field Usecases:");
                console.log(values);
                this.usecaseid = values;
                this.getConnectedByUsecaseId();
            }
        },
    }
</script>
